/*
 * Copyright (c) 2017-2018. Code réalisé par IpsoSenso
 */

import MenuList from '@material-ui/core/MenuList'

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'redux'
import { injectEntries, injectOpen } from 'isotope-client/components/menu/services/menuInjector'
import TenderBoxMenuEntry from './TenderBoxMenuEntry'
import { closeMenu } from 'isotope-client/components/menu/services/menuActions'

export class TenderBoxInternalMenu extends Component {

	render() {
		const { Component, entries, changeMenu, location, padding, code, closeMenu } = this.props

		return (
			<Component
				value={location.pathname}
				onChange={changeMenu}
			>
				{entries && entries.map((entry, index) => <TenderBoxMenuEntry
					padding={padding}
					key={index}
					entry={entry}
					changeMenu={changeMenu}
					location={location}
					closeMenu={closeMenu}
					code={code}
				/>)}
			</Component>
		)
	}
}

TenderBoxInternalMenu.propTypes = {
	code: PropTypes.string,
	location: PropTypes.object.isRequired,
	changeMenu: PropTypes.func.isRequired,
	entries: PropTypes.array,
	padding: PropTypes.number,
	closeMenu: PropTypes.func
}

TenderBoxInternalMenu.defaultProps = {
	padding: 0,
	Component: MenuList
}

const actions = {
	changeMenu: (value, state) => dispatch => dispatch(push(value, state)),
	closeMenu: closeMenu
}

export const TenderBoxConnectedMenu = connect(undefined, actions)(TenderBoxInternalMenu)

export default compose(
	injectEntries,
	injectOpen,
	connect(undefined, actions)
)(TenderBoxInternalMenu)
